import { useNuxtApp } from '#app'
import { useBasketStore } from '~/stores/basket'
import { AddonSaleBundleStrategy } from '~/models/Product/AddonSaleBundleStrategy'

export default (productId: number) => {
    const key = `productDetailAsyncData_${productId}`
    return useCachedAsyncData(
        key,
        300,
        async () => {
            const config = useRuntimeConfig()
            const nuxtApp = useNuxtApp()
            const basketStore = useBasketStore()

            const productDetailPromise = nuxtApp.$repository.getProductDetailDataAccess(productId, basketStore.uid ?? '')
            const reviewPromise =
                config.public.reviewClubEnabled === true ? nuxtApp.$repository.getProductReviewlist(productId) : Promise.resolve([])

            const addonSaleBundlesPromise = nuxtApp.$repository.getAddonSaleBundles(productId, AddonSaleBundleStrategy.Bundle)

            const [productDetailData, reviewResponse, addonSaleBundlesResponse] = await Promise.all([
                productDetailPromise,
                reviewPromise,
                addonSaleBundlesPromise,
            ])

            return {
                productDetailData,
                reviewResponse,
                addonSaleBundlesResponse,
            }
        },
        {
            lazy: hasCachedAsyncData(key),
        }
    )
}
